export function validateBlogUpdate(values) {
    let errors = {};

    if (!values.title) {
        errors.title = 'Title is required';
    }
    if (!values.subtitle) {
        errors.subtitle = 'Sub title is required';
    }
    if (!values.app) {
        errors.app = 'App is required';
    }
    if (values.status === 'published') {
        const textOnly = (values.content_html || '').replace(/<[^>]*>/g, '').trim();
        if (!textOnly) {
            errors.content_html = 'Content is required before publishing';
        }
    }
    return errors;
}

export function validateAuthor(values) {
    let errors = {};

    if (!values.name) {
        errors.name = 'Name is required';
    }
    if (values.linkedin_url && !/^https?:\/\//i.test(values.linkedin_url)) {
        errors.linkedin_url = 'Must be a full URL (starting with http:// or https://)';
    }

    return errors;
}

export function validateCreateUser(values) {
    let errors = {};

    if (!values.username) {
        errors.username = 'Username is required';
    }
    if (!values.password) {
        errors.password = 'Password is required';
    } else if (values.password.length < 8) {
        errors.password = 'Password must be 8 or more characters';
    }
    if (!values.confirmPassword) {
        errors.confirmPassword = 'Confirm Password is required';
    } else if (values.password !== values.confirmPassword) {
        errors.confirmPassword = 'Passwords should match';
    }

    return errors;
}

// Password is optional on edit: leaving it blank keeps the current password.
export function validateEditUser(values) {
    let errors = {};

    if (!values.username) {
        errors.username = 'Username is required';
    }
    if (values.password || values.confirmPassword) {
        if (!values.password || values.password.length < 8) {
            errors.password = 'Password must be 8 or more characters';
        }
        if (values.password !== values.confirmPassword) {
            errors.confirmPassword = 'Passwords should match';
        }
    }

    return errors;
}
